/* unplugin-vue-components disabled */import script from "./sourceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./sourceDetail.vue?vue&type=script&setup=true&lang=js"

import "./sourceDetail.vue?vue&type=style&index=0&id=2a6a1c0f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6a1c0f"]])

export default __exports__